import React, { useContext, useEffect, useState } from "react";
import { Table } from "flowbite-react";
import { Route, useNavigate } from 'react-router-dom';
import Validate from "../shared/validation/Validate";
import axios from "axios";
import { CurrencyFormatter } from "../utils/utils";
import { UserContext } from "../context";


const LocalCurrencyBalance = () => {
    const navigate = useNavigate();

    const { state } = useContext(UserContext);

    // user token for API request
    const token = JSON.parse(window.localStorage.getItem("auth"))?.token;

    // userDatail  for API request
    const userDetail = JSON.parse(window.localStorage.getItem("auth"))?.user;

    const [totalBalance, setTotalBalance] = useState(0);
    const [totalLocalBalance, setTotalLocalBalance] = useState(0);
    const [difference, setDifference] = useState(0);
    const [totalBalanceSafe, setTotalBalanceSafe] = useState(0);
    const [totalBalanceBulkCoins, setTotalBalanceBulkCoins] = useState(0);
    const [totalBalanceNotes, setTotalBalanceNotes] = useState(0);
    const [totalBalanceCoinsInTray, setTotalBalanceCoinsInTray] = useState(0);

    useEffect(() => {
        if(userDetail && userDetail.userRole ==='Admin' && userDetail.shopId === undefined){
            navigate('/shopSelection');
        }
    }, [])


    //Get the the total LocalCurrencyBalance Array to calculate the safe BulkCoins Notes and CoinsInTray
    const getLocalTotalBalance = async () => {
        const balance = await axios.get(process.env.REACT_APP_API_URL + 'getLocalCurrencyBalance', {
            params: { balanceType: 'all', shopId: userDetail?.shopId },
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        //totalling the Total Field of Safe BulkCoins Notes and CoinsInTray
        if (balance.data.length !== 0) {
            setTotalLocalBalance(balance.data && balance.data.reduce((acc, val) => acc + (val.total || 0), 0));
            setTotalBalanceSafe(balance.data && balance.data.filter((data) => data.balanceType === "safe").reduce((acc, val) => acc + (val.total || 0), 0));
            setTotalBalanceBulkCoins(balance.data && balance.data.filter((data) => data.balanceType === "bulkcoins").reduce((acc, val) => acc + (val.total || 0), 0));
            setTotalBalanceNotes(balance.data && balance.data.filter((data) => data.balanceType === "notes").reduce((acc, val) => acc + (val.total || 0), 0));
            setTotalBalanceCoinsInTray(balance.data && balance.data.filter((data) => data.balanceType === "coinsintray").reduce((acc, val) => acc + (val.total || 0), 0));
        }
    }



    //Get the total new Balance Array to calculate the safe BulkCoins Notes and CoinsInTray
    const getTotalBalance = async () => {
        const balance = await axios.get(process.env.REACT_APP_API_URL + 'getLocalBalance', {
            params: { shopId: userDetail?.shopId },
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        //totalling the Total Field of Safe BulkCoins Notes and CoinsInTray
        if (balance.data !== null) {
            setTotalBalance(balance.data.totalAmount);
        }
    }


    useEffect(() => {
        getTotalBalance();
    }, [state?.user?._id]);


    useEffect(() => {
        getLocalTotalBalance();
    }, [state?.user?._id]);


    // Update difference whenever totalBalance or newBalance changes
    useEffect(() => {
        const absoluteDifference = Math.abs(totalLocalBalance - totalBalance);
        setDifference(absoluteDifference);
    }, [totalLocalBalance, totalBalance]);



    return (
        <Validate>
            <div className="">
                {/* <Route path="/bulk-coins" component={BulkCoins} /> */}
                {/* <Route path="/bulk-coins-balance" component={BulkCoinsBalance} />
            <Route path="/notes-balance" component={NotesBalance} />
            <Route path="/coins-in-tray-balance" component={CoinsInTrayBalance} /> */}
                <div className="">
                    {/* <h1 className="text-headings text-3xl font-medium mt-10">Local Currency Balance</h1> */}
                </div>
                <div className="overflow-x-auto">
                    <Table className="mb-8">
                        <Table.Head className=" shadow-inner">
                            <Table.HeadCell className=' shadow-none'><span className="font-medium text-lg text-white bg-theme-secondary border-theme-secondary rounded-lg px-3 py-2">Difference</span><span className={`ml-2 font-semibold text-lg ${totalBalance > totalLocalBalance ? "text-green-500" : totalBalance < totalLocalBalance ? "text-red-500" : ""}`}>{totalBalance < totalLocalBalance ? "-" : totalBalance > totalLocalBalance ? "+" : ""}</span><span className={`ml-2 font-semibold text-lg ${totalBalance > totalLocalBalance ? "text-green-500" : totalBalance < totalLocalBalance ? "text-red-500" : ""}`}>{CurrencyFormatter(difference, "aud")}/-</span></Table.HeadCell>
                            <Table.HeadCell className=' shadow-none'><span className="font-medium text-lg text-white bg-theme-secondary border-theme-secondary rounded-lg px-3 py-2">Opening Balance</span><span className="ml-2 font-semibold text-lg ">{CurrencyFormatter(totalBalance, "aud")}/-</span></Table.HeadCell>
                            <Table.HeadCell className=' shadow-none px-0 mx-0'><span className="font-medium text-lg text-white bg-theme-secondary border-theme-secondary rounded-lg px-3 py-2">Total</span><span className="ml-2 font-semibold text-lg ">{CurrencyFormatter(totalLocalBalance, "aud")}/-</span></Table.HeadCell>
                        </Table.Head>
                    </Table>

                    <Table>

                        <Table.Head>
                            <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Balance Inquiry</Table.HeadCell>
                            {/* <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Description</Table.HeadCell> */}
                            <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Balance</Table.HeadCell>
                            <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Action</Table.HeadCell>
                        </Table.Head>
                        <Table.Body className="divide-y">
                            <Table.Row className="bg-slate-200 dark:border-gray-700 dark:bg-gray-800">
                                <Table.Cell className="whitespace-nowrap font-bold text-lg text-theme-primary">&nbsp;&nbsp;&nbsp;&nbsp;Safe</Table.Cell>
                                {/* <Table.Cell>&nbsp;&nbsp;&nbsp;&nbsp;Lorem ipsum dolor sit amet sonsecterue. Lorem ipsum dolor sit amet consectetur.</Table.Cell> */}
                                <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{CurrencyFormatter(totalBalanceSafe, "aud")}</Table.Cell>
                                <Table.Cell>&nbsp;&nbsp;&nbsp;&nbsp;<button className='bg-gradient-to-br from-theme-primary to-theme-secondary text-white px-5 py-2 rounded-lg' onClick={() => navigate('/safe')}>Open</button></Table.Cell>
                            </Table.Row>
                            <Table.Row className="dark:border-gray-700 dark:bg-gray-800">
                                <Table.Cell className="whitespace-nowrap font-bold text-lg text-theme-primary">&nbsp;&nbsp;&nbsp;&nbsp;Bulk Coins</Table.Cell>
                                {/* <Table.Cell>&nbsp;&nbsp;&nbsp;&nbsp;Lorem ipsum dolor sit amet sonsecterue. Lorem ipsum dolor sit amet consectetur.</Table.Cell> */}
                                <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{CurrencyFormatter(totalBalanceBulkCoins, "aud")}</Table.Cell>
                                <Table.Cell>&nbsp;&nbsp;&nbsp;&nbsp;<button className='bg-gradient-to-br from-theme-primary to-theme-secondary text-white px-5 py-2 rounded-lg' onClick={() => navigate('/bulk-coins')}>Open</button></Table.Cell>
                            </Table.Row>
                            <Table.Row className="bg-slate-200 dark:border-gray-700 dark:bg-gray-800">
                                <Table.Cell className="whitespace-nowrap font-bold text-lg text-theme-primary">&nbsp;&nbsp;&nbsp;&nbsp;Notes</Table.Cell>
                                {/* <Table.Cell>&nbsp;&nbsp;&nbsp;&nbsp;Lorem ipsum dolor sit amet sonsecterue. Lorem ipsum dolor sit amet consectetur.</Table.Cell> */}
                                <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{CurrencyFormatter(totalBalanceNotes, "aud")}</Table.Cell>
                                <Table.Cell>&nbsp;&nbsp;&nbsp;&nbsp;<button className='bg-gradient-to-br from-theme-primary to-theme-secondary text-white px-5 py-2 rounded-lg' onClick={() => navigate('/notes')}>Open</button></Table.Cell>
                            </Table.Row>
                            <Table.Row className="dark:border-gray-700 dark:bg-gray-800">
                                <Table.Cell className="whitespace-nowrap font-bold text-lg text-theme-primary">&nbsp;&nbsp;&nbsp;&nbsp;Coins in Tray</Table.Cell>
                                {/* <Table.Cell>&nbsp;&nbsp;&nbsp;&nbsp;Lorem ipsum dolor sit amet sonsecterue. Lorem ipsum dolor sit amet consectetur.</Table.Cell> */}
                                <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{CurrencyFormatter(totalBalanceCoinsInTray, "aud")}</Table.Cell>
                                <Table.Cell>&nbsp;&nbsp;&nbsp;&nbsp;<button className='bg-gradient-to-br from-theme-primary to-theme-secondary text-white px-5 py-2 rounded-lg' onClick={() => navigate('/coins-in-tray')}>Open</button></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </div>
            </div>
        </Validate>
    )
}

export default LocalCurrencyBalance;